import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MessageService } from 'src/app/services/message/message.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-application-data',
  templateUrl: './application-data.component.html',
  styleUrls: ['./application-data.component.css']
})
export class ApplicationDataComponent implements OnInit {

  selectedFile: any;
  fileName: string;
  jsonString: string = "";
  uploadString: string = "";
  uploadData: any;

  collectionName: string = "";
  key: string = "";

  applicationData: Array<any> = [];
  collectionNames: Array<string> = [];
  keys: Array<any> = [];

  @ViewChild('uploader') uploader;

  constructor(private telecomService: TelecomService, private timeService: TimeService, private auth: AuthService, private message: MessageService) { }

  ngOnInit(): void {
    this.getApplicationData();
  }

  getApplicationData(){
    let params = {
      FunctionName: environment.ApplicationDataLambdaName,
      Payload: JSON.stringify({
        operation: 'get'
      })
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to retrieve data: ').then((response: any) => {
      console.log(response);
      if(response.status == 200){
        this.applicationData = response.data;
        this.buildCollectionList();
        this.buildKeyList();
      }else{
        this.message.setNotification("Failed to receive application data. If the issue persists, contact technical support.", "error", true);
      }
    });
  }

  setApplicationData(){
    
    if(!confirm("Are you sure that you want to make changes to configuration data?")){
      return;
    }
    
    var item = {
      collectionName: this.collectionName,
      Key: this.key,
      data: this.uploadData,
      lastUpdated: this.timeService.getDateTimeString(new Date()),
      updatedBy: this.auth.currentUser
    }

    //if preexisting object, merge objects just in case
    for(let x=0; x<this.applicationData.length; x++){
      var row = this.applicationData[x];
      if(row.collectionName == this.collectionName && row.Key == this.key){
        item = Object.assign(row, item);
        break;
      }
    }

    let params = {
      FunctionName: environment.ApplicationDataLambdaName,
      Payload: JSON.stringify({
        operation: 'update',
        data: item
      })
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to update application data: ').then((response: any) => {
      if(response.status == 200){
        this.message.setNotification("Application Configuration Updated Successfully", "success", true);
        this.cancel();
        this.getApplicationData();
      }else{
        this.message.setNotification("Failed to update Application Configuration", "error", true);
      }
    });
  }

  // create collectionName options from applicationData
  buildCollectionList(){
    this.collectionNames = [];
    this.applicationData.forEach(row =>{
      if(!this.collectionNames.includes(row.collectionName)){
        this.collectionNames.push(row.collectionName);
      }
    });
    console.log("collectionNames: ", this.collectionNames);
  }

  // create key options from applicationData
  buildKeyList(){
    this.keys = [];
    this.applicationData.forEach(row => {
      if(this.collectionNames.includes(this.collectionName)){
        if(row.collectionName == this.collectionName){
          this.keys.push(row.Key);
        }
      }else{
        if(!this.keys.includes(row.Key)){
          this.keys.push(row.Key);
        }
      }
    });
    console.log("keys: ", this.keys);
  }

  uploadFile($event) {
    this.selectedFile = $event.target.files[0];
    this.fileName = this.selectedFile.name;
    console.log('name: ', this.selectedFile.name);
    console.log('size: ', this.selectedFile.size);
    console.log('type: ', this.selectedFile.type);
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);
    reader.onload = (e) => {
      try{
        console.log('load file event: ', e);
        var content = reader.result as string;
        this.uploadString = JSON.stringify(JSON.parse(content), null, 4);
        this.uploadData = JSON.parse(content);
      }catch(e){
        console.error(e);
        this.message.setNotification(`Failed to load JSON from \"${this.fileName}\"`, "error", true);
      }
    }
    this.uploader.nativeElement.value = '';
  }

  setCollectionName(event){
    this.collectionName = event.value;
  }

  collectionNameChange(){
    this.jsonString = "";
    this.key = "";
    this.buildKeyList();
  }

  //set value, populate jsonString if match present in applicationData
  setKey(event){
    this.key = event.value;
    if(this.collectionName !== ""){
      let match = false;
      for(let x=0; x<this.applicationData.length; x++){
        var row = this.applicationData[x];
        if(row.collectionName == this.collectionName && row.Key == this.key){
          match = true;
          console.log(row);
          this.jsonString = JSON.stringify(row.data, null, 4);
          break;
        }
      }
      if(!match){
        this.jsonString = "";
      }
    }
  }
  
  copyText(){
    navigator.clipboard.writeText(this.jsonString).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  cancel(){
    // this.collectionName = "";
    // this.key = "";
    // this.jsonString = "";
    this.uploadString = "";
    this.fileName = "";
    this.uploadData = null;
  }

}
